import {putAsync} from '../../../services/http/http';
import {ThunkAsyncAction} from '../../appThunk';
import {getOriginalConversations} from '../dataSelectors';

export function setRecipientIsBlockedAsyncAction(
  conversationId: number,
  isBlocked: boolean,
): ThunkAsyncAction {
  return async (_dispatch, getState) => {
    const state = getState();
    const conversation = getOriginalConversations(state)[conversationId];
    const recipientUrl = conversation?.recipient?.url;

    if (!recipientUrl) {
      return;
    }

    await putAsync(recipientUrl, {is_spammer: isBlocked});
  };
}
